import { Chip, Flex, Text } from '@servicetitan/anvil2';
import { Calculation } from '@servicetitan/financing-api-client';
import { formatCurrency } from '@servicetitan/financing-utils-shared';
import { detailRow, monthlyPayment, planRow } from './AffirmPaymentOptionsScreen.module.css';
import { core } from '@servicetitan/anvil2/token';

interface AffirmPlanRowProps {
    plan: Calculation;
}

const formatPaymentAmount = (amount: number) =>
    formatCurrency(amount, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const getAprCost = (plan: Calculation) =>
    plan.totalAmount != null ? plan.totalAmount - plan.loanAmount : 0;

export const AffirmPlanRow = ({ plan }: AffirmPlanRowProps) => {
    const totalAmount = plan.totalAmount ?? plan.loanAmount;

    return (
        <div className={planRow}>
            <Flex
                justifyContent="space-between"
                alignItems="center"
                style={{ marginBottom: '0.5rem' }}
            >
                <Text variant="body" className={monthlyPayment} size="medium">
                    <strong>{formatPaymentAmount(plan.defaultMonthlyPayment)}</strong>
                    /mo
                </Text>
                <Chip
                    label={`${plan.defaultTerms} months`}
                    color={core.primitive.ColorBlue100.value}
                />
            </Flex>
            <Flex justifyContent="space-between" alignItems="center" className={detailRow}>
                <Text variant="eyebrow">APR ({plan.defaultRate}%)</Text>
                <Text>{formatCurrency(getAprCost(plan))}</Text>
            </Flex>
            <Flex justifyContent="space-between" alignItems="center" className={detailRow}>
                <Text variant="eyebrow">TOTAL</Text>
                <Text>{formatCurrency(totalAmount)}</Text>
            </Flex>
        </div>
    );
};
